import { createFileRoute, Outlet } from '@tanstack/react-router'

import { SettingsPage } from '@/components/Internal/SettingsPage'

/** Every page in the group is a datasheet on the same scrolling ground. */
export const Route = createFileRoute('/internal/system/settings')({
  component: () => (
    <SettingsPage>
      <Outlet />
    </SettingsPage>
  ),
})
